import { useEffect, useState } from "react";
import { useStateValue } from "../../context/StateProvider";
import { formatNumberShort } from "../../utils/helper";
import YearFilterDropdown from "./YearFilterDropdown";
import StatDetails from "./../deals/StatDetails";

function TeamPerformanceStats({ id, childSelectedYear, isWidth = true }) {
  const [{ users, deals }] = useStateValue();

  const [selectedMonth, setSelectedMonth] = useState(null);
  const [statspopup, setstatspopup] = useState(false);
  const [selectedstat, setselectedstat] = useState("");
  const [statsdata, setstatsdata] = useState([]);

  const currentYear = new Date().getFullYear();

  const currentMonth = new Date().getMonth() + 1;
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const yearsList = Array.from({ length: 5 }, (_, i) => currentYear - i);
  const [filterYear, setFilterYear] = useState(String(currentYear));
  const [yearDropdownVisible, setYearDropdownVisible] = useState(false);

  useEffect(() => {
    setSelectedMonth((prev) =>
      prev
        ? { month: prev.month, year: Number(filterYear) }
        : { month: currentMonth, year: Number(filterYear) },
    );
    childSelectedYear(selectedYear);
  }, [selectedYear]);

  // Find selected user
  const selectedUser = users.find((u) => String(u.id) === String(id));
  if (!selectedUser) return <div>User not found</div>;

  const { firstname, lastname, role } = selectedUser;

  // All deals of the user
  const matchedDeals = deals.filter((deal) => {
    if (role === "Admin")
      return (
        deal.assignedteamlead === selectedUser.id ||
        deal.agentData === selectedUser.id
      );
    return deal.agentData === selectedUser.id;
  });

  const months = Array.from({ length: 12 }, (_, i) => ({
    month: i + 1,
    year: selectedYear,
  }));

  // Build monthly data
  const monthlyData = months.map(({ month, year }) => {
    const monthlyDeals = matchedDeals.filter((d) => {
      const dd = new Date(d.closingdate);
      return dd.getFullYear() === year && dd.getMonth() + 1 === month;
    });

    const monthlyDealsPending = matchedDeals.filter((d) => {
      const dd = new Date(d.closingdate);
      return dd.getFullYear() === year && dd.getMonth() + 1 === month;
    });

    const closed = monthlyDeals
      .filter((d) => d.dealStage.toLowerCase() === "closed")
      .reduce(
        (sum, d) =>
          sum +
          Number(
            role === "Admin"
              ? d.assignedteamlead === id
                ? d.teamleadCommissionamount || 0
                : d.agentCommissionamount || 0
              : d.agentCommissionamount || 0,
          ),
        0,
      );

    const pending = monthlyDealsPending
      .filter(
        (d) =>
          !["closed", "cancelled", "expired"].includes(
            d.dealStage.toLowerCase(),
          ),
      )
      .reduce(
        (sum, d) =>
          sum +
          Number(
            role === "Admin"
              ? d.assignedteamlead === id
                ? d.teamleadCommissionamount || 0
                : d.agentCommissionamount || 0
              : d.agentCommissionamount || 0,
          ),
        0,
      );

    const closedDealsCount = monthlyDeals.filter(
      (d) =>
        d.dealStage.toLowerCase() === "closed" &&
        (role === "Admin"
          ? d?.agentData == selectedUser.id ||
            (d?.splittype == "NoSplit" &&
              d?.assignedteamlead == selectedUser.id) ||
            (d?.splittype === "Referral" && d?.agentData == "") ||
            (d?.splittype === "TeamSplit" && d?.inhousereferral == true)
          : d?.agentData == selectedUser.id && d?.inhousereferral != true),
    ).length;

    return {
      month,
      year,
      closedCommission: closed,
      pendingCommission: pending,
      netCommission: closed + pending,
      closedDealsCount,
    };
  });

  // Current year totals
  const closedDealsCount = matchedDeals.filter(
    (d) =>
      d.dealStage.toLowerCase() === "closed" &&
      new Date(d.closingdate).getFullYear() === selectedYear &&
      (role === "Admin"
        ? d?.agentData == selectedUser.id ||
          (d?.splittype == "NoSplit" &&
            d?.assignedteamlead == selectedUser.id) ||
          (d?.splittype === "Referral" && d?.agentData == "") ||
          (d?.splittype === "TeamSplit" && d?.inhousereferral == true)
        : d?.agentData == selectedUser.id && d?.inhousereferral != true),
  );

  const closedDealsData = matchedDeals.filter(
    (d) =>
      d.dealStage.toLowerCase() === "closed" &&
      new Date(d.closingdate).getFullYear() === selectedYear,
  );

  const ytdVolume = matchedDeals
    .filter(
      (d) =>
        d.dealStage.toLowerCase() === "closed" &&
        new Date(d.closingdate).getFullYear() === selectedYear &&
        (role === "Admin"
          ? d?.agentData == selectedUser.id ||
            (d?.splittype == "NoSplit" &&
              d?.assignedteamlead == selectedUser.id) ||
            (d?.splittype === "Referral" && d?.agentData == "") ||
            (d?.splittype === "TeamSplit" && d?.inhousereferral == true)
          : d?.agentData == selectedUser.id && d?.inhousereferral != true),
    )
    .reduce((sum, d) => sum + Number(d.offerPrice || 0), 0);

  const closedCommissionTotal = monthlyData.reduce(
    (sum, m) => sum + m.closedCommission,
    0,
  );

  const pendingDealsYTD = matchedDeals.filter((d) => {
    if (!d.closingdate) return false;

    const dealYear = new Date(d.closingdate).getFullYear();
    if (dealYear !== selectedYear) return false;

    const stage = d.dealStage?.toLowerCase();
    if (["closed", "cancelled", "expired"].includes(stage)) return false;

    // role-based safety (extra safe)
    if (role === "Admin") {
      return (
        d.assignedteamlead === selectedUser.id ||
        d.agentData === selectedUser.id
      );
    }

    return d.agentData === selectedUser.id;
  });

  const closedDealsYTD = matchedDeals.filter((d) => {
    if (!d.closingdate) return false;

    const dealYear = new Date(d.closingdate).getFullYear();
    if (dealYear !== selectedYear) return false;

    return d.dealStage?.toLowerCase() === "closed";
  });

  const pendingCommissionTotal = pendingDealsYTD.reduce(
    (sum, d) =>
      sum +
      Number(
        role === "Admin"
          ? d.assignedteamlead === id
            ? d.teamleadCommissionamount || 0
            : d.agentCommissionamount || 0
          : d.agentCommissionamount || 0,
      ),
    0,
  );

  const netCommissionDealsYTD = [...closedDealsYTD, ...pendingDealsYTD];

  const netCommissionTotal = netCommissionDealsYTD.reduce(
    (sum, d) =>
      sum +
      Number(
        role === "Admin"
          ? d.assignedteamlead === id
            ? d.teamleadCommissionamount || 0
            : d.agentCommissionamount || 0
          : d.agentCommissionamount || 0,
      ),
    0,
  );

  const monthNames = [
    "",
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const selectedMonthData =
    selectedMonth &&
    monthlyData.find(
      (m) => m.month === selectedMonth.month && m.year === selectedMonth.year,
    );

  return (
    <div className="">
      <section
        class={`flex flex-wrap gap-x-[2%] gap-y-5 my-10 ${isWidth ? "w-[96%] mx-auto" : ""}`}
      >
        <div
          class="w-full lg:w-[32%] group relative bg-white px-7 py-5 rounded-2xl border border-gray-200 shadow-sm
          transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]
          overflow-hidden hover:-translate-y-[5px] hover:shadow-lg hover:border-[#1E293B] cursor-pointer"
          onClick={() => {
            setstatspopup(true);
            setselectedstat("Deals - Closed Volume");
            setstatsdata(closedDealsCount);
          }}
        >
          <span
            class="absolute top-0 left-0 h-1 w-full bg-gradient-to-r from-[#0f172a] to-[#1E293B]
            transform -translate-x-full transition-transform duration-500 ease-in-out
            group-hover:translate-x-0"
          ></span>

          <div class="flex justify-between items-center mb-2">
            <div
              class="w-14 h-14 flex items-center justify-center rounded-2xl
              bg-gradient-to-br from-blue-50 to-blue-100 text-blue-500 text-3xl
              transition-transform duration-300 ease-in-out group-hover:rotate-6 group-hover:scale-110"
            >
              💰
            </div>
          </div>

          <div
            id="totalSalesVolume"
            class="text-4xl font-bold mb-2 bg-gradient-to-r from-[#0f172a] to-[#1E293B]
            bg-clip-text text-transparent"
          >
            {formatNumberShort(ytdVolume)}
          </div>
          <div class="text-gray-500 text-sm font-medium">YTD Volume</div>
        </div>

        <div
          class="w-full lg:w-[32%] group relative bg-white px-7 py-5 rounded-2xl border border-gray-200 shadow-sm
          transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]
          overflow-hidden hover:-translate-y-[5px] hover:shadow-lg hover:border-green-500 cursor-pointer"
          onClick={() => {
            setstatspopup(true);
            setselectedstat("Deals - Closed");
            setstatsdata(closedDealsCount);
          }}
        >
          <span
            class="absolute top-0 left-0 h-1 w-full bg-gradient-to-r from-green-500 to-emerald-400
            transform -translate-x-full transition-transform duration-500 ease-in-out
            group-hover:translate-x-0"
          ></span>

          <div class="flex justify-between items-center mb-2">
            <div
              class="w-14 h-14 flex items-center justify-center rounded-2xl
              bg-gradient-to-br from-emerald-50 to-green-100 text-green-500 text-3xl
              transition-transform duration-300 ease-in-out group-hover:rotate-6 group-hover:scale-110"
            >
              👥
            </div>
          </div>

          <div
            id="grossCommission"
            class="text-4xl font-bold mb-2 bg-gradient-to-r from-gray-900 to-green-500
            bg-clip-text text-transparent"
          >
            {formatNumberShort(closedDealsCount.length)}
          </div>
          <div class="text-gray-500 text-sm font-medium">Closed Deals</div>
        </div>

        <div
          class="w-full lg:w-[32%] group relative bg-white px-7 py-5 rounded-2xl border border-gray-200 shadow-sm
          transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]
          overflow-hidden hover:-translate-y-[5px] hover:shadow-lg hover:border-amber-500 cursor-pointer"
          onClick={() => {
            setstatspopup(true);
            setselectedstat("Deals - Closed Commission Volume");
            setstatsdata(closedDealsData);
          }}
        >
          <span
            class="absolute top-0 left-0 h-1 w-full bg-gradient-to-r from-amber-500 to-orange-400
            transform -translate-x-full transition-transform duration-500 ease-in-out
            group-hover:translate-x-0"
          ></span>

          <div class="flex justify-between items-center mb-2">
            <div
              class="w-14 h-14 flex items-center justify-center rounded-2xl
              bg-gradient-to-br from-orange-50 to-amber-100 text-orange-500 text-3xl
              transition-transform duration-300 ease-in-out group-hover:rotate-6 group-hover:scale-110"
            >
              💰
            </div>
          </div>

          <div
            id="brokerShare"
            class="text-4xl font-bold mb-2 bg-gradient-to-r from-gray-900 to-amber-500
            bg-clip-text text-transparent"
          >
            ${formatNumberShort(closedCommissionTotal)}
          </div>
          <div class="text-gray-500 text-sm font-medium">
            Closed Commission YTD
          </div>
        </div>
        <div
          class="w-full lg:w-[32%] group relative bg-white px-7 py-5 rounded-2xl border border-gray-200 shadow-sm
          transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]
          overflow-hidden hover:-translate-y-[5px] hover:shadow-lg hover:border-amber-500 cursor-pointer"
          onClick={() => {
            setstatspopup(true);
            setselectedstat("Deals - Pending Commission Volume");
            setstatsdata(pendingDealsYTD);
          }}
        >
          <span
            class="absolute top-0 left-0 h-1 w-full bg-gradient-to-r from-amber-500 to-orange-400
            transform -translate-x-full transition-transform duration-500 ease-in-out
            group-hover:translate-x-0"
          ></span>

          <div class="flex justify-between items-center mb-2">
            <div
              class="w-14 h-14 flex items-center justify-center rounded-2xl
              bg-gradient-to-br from-orange-50 to-amber-100 text-orange-500 text-3xl
              transition-transform duration-300 ease-in-out group-hover:rotate-6 group-hover:scale-110"
            >
              💰
            </div>
          </div>

          <div
            id="brokerShare"
            class="text-4xl font-bold mb-2 bg-gradient-to-r from-gray-900 to-amber-500
            bg-clip-text text-transparent"
          >
            ${formatNumberShort(pendingCommissionTotal)}
          </div>
          <div class="text-gray-500 text-sm font-medium">
            Pending Commission YTD
          </div>
        </div>
        <div
          class="w-full lg:w-[32%] group relative bg-white px-7 py-5 rounded-2xl border border-gray-200 shadow-sm
          transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]
          overflow-hidden hover:-translate-y-[5px] hover:shadow-lg hover:border-amber-500 cursor-pointer"
          onClick={() => {
            setstatspopup(true);
            setselectedstat("Deals - Closed Commission Volume");
            setstatsdata(netCommissionDealsYTD);
          }}
        >
          <span
            class="absolute top-0 left-0 h-1 w-full bg-gradient-to-r from-amber-500 to-orange-400
            transform -translate-x-full transition-transform duration-500 ease-in-out
            group-hover:translate-x-0"
          ></span>

          <div class="flex justify-between items-center mb-2">
            <div
              class="w-14 h-14 flex items-center justify-center rounded-2xl
              bg-gradient-to-br from-orange-50 to-amber-100 text-orange-500 text-3xl
              transition-transform duration-300 ease-in-out group-hover:rotate-6 group-hover:scale-110"
            >
              💰
            </div>
          </div>

          <div
            id="brokerShare"
            class="text-4xl font-bold mb-2 bg-gradient-to-r from-gray-900 to-amber-500
            bg-clip-text text-transparent"
          >
            ${formatNumberShort(netCommissionTotal)}
          </div>
          <div class="text-gray-500 text-sm font-medium">
            Net Commission YTD
          </div>
        </div>
      </section>

      {/* YEARLY BAR CHART */}
      <div
        className={`bg-white shadow rounded-xl p-6 ${isWidth ? "w-[96%] mx-auto" : ""}`}
      >
        <div className="flex flex-wrap justify-between items-center mb-3">
          <h3 className="text-xl font-semibold mb-4">Yearly Performance</h3>
          <div className="relative w-full sm:w-auto">
            <button
              onClick={() => setYearDropdownVisible(!yearDropdownVisible)}
              className="border border-gray-300 rounded-md px-3 py-1 text-sm w-full sm:w-auto text-left bg-white"
            >
              {filterYear}
            </button>

            <YearFilterDropdown
              visible={yearDropdownVisible}
              onSelect={(year) => {
                setFilterYear(year);
                setSelectedYear(Number(year)); // 👈 performance logic sync
                setYearDropdownVisible(false);
              }}
              activateOutsideClick={() => setYearDropdownVisible(false)}
              style={{ top: "40px", right: "0px" }}
            />
          </div>
        </div>

        <div className="flex items-end gap-2">
          {monthlyData.map((m, i) => {
            const maxNetValue = Math.max(
              ...monthlyData.map((d) => d.netCommission),
              1,
            );
            const barHeight = Math.max(
              10,
              (m.netCommission / maxNetValue) * 160,
            );

            const isSelected =
              selectedMonth?.month === m.month &&
              selectedMonth?.year === m.year;

            return (
              <div
                key={i}
                className="flex-1 flex flex-col items-center cursor-pointer transition-all"
                onClick={() =>
                  setSelectedMonth(
                    isSelected ? null : { month: m.month, year: m.year },
                  )
                }
              >
                <div
                  className={`w-full rounded-t-md transition-all ${
                    isSelected
                      ? "bg-[#1E293B]"
                      : "bg-indigo-300 hover:bg-[#1E293B]"
                  }`}
                  style={{ height: `${barHeight}px` }}
                ></div>
                <p
                  className={`text-xs mt-2 ${
                    isSelected
                      ? "text-[#1E293B] font-semibold"
                      : "text-gray-500"
                  }`}
                >
                  {monthNames[m.month]}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      {/* SELECTED MONTH DETAILS */}
      {selectedMonthData && (
        <div
          className={`bg-white shadow rounded-xl p-6 my-8 ${isWidth ? "w-[96%] mx-auto" : ""}`}
        >
          <h3 className="text-xl font-semibold mb-3">
            {monthNames[selectedMonthData.month]} {selectedMonthData.year}{" "}
            Summary
          </h3>

          <div className="flex flex-wrap justify-between mt-5 gap-y-8">
            <div className="w-full lg:w-[23%]">
              <p className="text-gray-500">Closed Deals</p>
              <h2 className="text-3xl font-bold mt-1 text-gray-800">
                {formatNumberShort(selectedMonthData.closedDealsCount)}
              </h2>
            </div>
            <div className="w-full lg:w-[23%]">
              <p className="text-gray-500">Closed Commission</p>
              <h2 className="text-3xl font-bold mt-1 text-[#10B981]">
                ${formatNumberShort(selectedMonthData.closedCommission)}
              </h2>
            </div>

            <div className="w-full lg:w-[23%]">
              <p className="text-gray-500">Pending Commission</p>
              <h2 className="text-3xl font-bold mt-1 text-[#F59E0B]">
                ${formatNumberShort(selectedMonthData.pendingCommission)}
              </h2>
            </div>

            <div className="w-full lg:w-[23%]">
              <p className="text-gray-500">Net Commission</p>
              <h2 className="text-3xl font-bold mt-1 text-gray-800">
                ${formatNumberShort(selectedMonthData.netCommission)}
              </h2>
            </div>
          </div>
        </div>
      )}
      {statspopup && (
        <StatDetails
          // isLoading={isLoading}
          Data={statsdata}
          selectedstat={selectedstat}
          onClose={() => setstatspopup(false)}
          isStatCard={true}
          statUserId={id}
          role={role}
          onSubmit={(data) => {
            alert(data);
          }}
        />
      )}
    </div>
  );
}

export default TeamPerformanceStats;
